var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4488 20.1739C31.8075 18.843 32 17.4442 32 16C32 14.5558 31.8075 13.1569 31.4488 11.826L14.6087 0.0608521C11.4824 0.330227 8.61344 1.49835 6.26088 3.30591L0.551188 11.826C0.1925 13.1569 0 14.5558 0 16C0 17.4357 0.190188 18.8269 0.544875 20.1508L6.26081 28.694C8.61337 30.5016 11.4823 31.6698 14.6086 31.9391L31.4488 20.1739Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.551025 20.174C1.47678 23.6089 3.51709 26.586 6.26071 28.6941V20.174H0.551025Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6086 31.9391C15.0673 31.9786 15.5311 32 16 32C23.3924 32 29.6128 26.9862 31.4488 20.174H14.6086V31.9391Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4488 11.8261C29.6128 5.01381 23.3924 0 16 0C15.5311 0 15.0673 0.021375 14.6086 0.060875V11.8261H31.4488Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26071 3.30591C3.51709 5.41403 1.47678 8.3911 0.551025 11.826H6.26071V3.30591Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9131H12.5218H12.5218V0.38031C11.0431 0.708185 9.64131 1.23962 8.34781 1.94544V13.913H0.135438C0.046375 14.5962 0 15.2927 0 16C0 16.7073 0.046375 17.4038 0.135438 18.0869H8.34775H8.34781V30.0545C9.64131 30.7603 11.0431 31.2918 12.5218 31.6196V18.0871V18.087H31.8646C31.9535 17.4038 32 16.7073 32 16C32 15.2927 31.9535 14.5962 31.8646 13.9131V13.9131Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAx);
export default __webpack_public_path__ + "static/media/AX.ad3b4fdf.svg";
export { ForwardRef as ReactComponent };